function initSplideSlider(slideSection) {
  if (!slideSection || slideSection.classList.contains('splide-initialized')) {
    console.log(`[Splide] Slider #${slideSection?.dataset.sliderId} already initialized or invalid.`);
    return;
  }

  const sliderId = slideSection.dataset.sliderId;
  const slideCount = parseInt(slideSection.dataset.slideCount || '0', 10);

  // Parse settings from data attributes (use defaults if needed)
  const settings = {
    desktopSlides: parseInt(slideSection.dataset.desktopSlides || '1', 10),
    mobileSlides: parseInt(slideSection.dataset.mobileSlides || '1', 10),
    desktopScroll: parseInt(slideSection.dataset.desktopScroll || '1', 10),
    mobileScroll: parseInt(slideSection.dataset.mobileScroll || '1', 10),
    infinite: slideSection.dataset.infinite === 'true',
    autoplay: slideSection.dataset.autoplay === 'true',
    autoplaySpeed: parseInt(slideSection.dataset.autoplaySpeed || '3000', 10),
    arrows: slideSection.dataset.arrows === 'true',
    dots: slideSection.dataset.dots === 'true',
    draggable: slideSection.dataset.draggable === 'true',
    freescroll: slideSection.dataset.freescroll === 'true',
    adaptiveHeight: slideSection.dataset.adaptiveHeight === 'true',
  };

  console.log(`[Splide] Initializing slider #${sliderId} with settings:`, settings);

  // Helper functions for responsive logic
  const getBreakpoint = () => (window.innerWidth <= 768 ? 'mobile' : 'desktop');

  const getSlidesToShow = (breakpoint) =>
    breakpoint === 'mobile' ? settings.mobileSlides : settings.desktopSlides;

  const shouldInit = () => slideCount > getSlidesToShow(getBreakpoint());

  let splideInstance = null;
  let currentBreakpoint = getBreakpoint();

  function mountSlider() {
    if (!shouldInit()) {
      // Not enough slides to slide, make it static
      slideSection.classList.add('is-static');
      console.log(`[Splide] Slider #${sliderId} set to static (not enough slides)`);
      return;
    }

    // Initialize Splide slider
    const options = {
      type: settings.infinite ? 'loop' : 'slide',
      perPage: settings.desktopSlides,
      perMove: settings.desktopScroll,
      breakpoints: {
        768: {
          perPage: settings.mobileSlides,
          perMove: settings.mobileScroll,
        },
      },
      autoplay: settings.autoplay,
      interval: settings.autoplaySpeed,
      arrows: settings.arrows,
      pagination: settings.dots,
      drag: settings.draggable,
      flickPower: 500,
      heightRatio: settings.adaptiveHeight ? null : 1,
      // Add freeScroll if you want:
      // Note: Splide freeScroll option requires the Splide extension or custom handling
      // freeScroll: settings.freescroll, 
    };

    splideInstance = new Splide(slideSection, options);

    splideInstance.on('mounted', () => {
      console.log(`[Splide] Slider #${sliderId} mounted`);

      // Accessibility tweaks
      const slides = slideSection.querySelectorAll('.splide__slide');
      const slideList = slideSection.querySelector('.splide__list');

      slides.forEach((slide) => {
        slide.setAttribute('role', 'listitem');
      });

      if (slideList) {
        slideList.setAttribute('role', 'list');
      }
    });

    splideInstance.mount();
    slideSection.classList.add('splide-initialized');
    console.log(`[Splide] Slider #${sliderId} mounted and initialized`);
  }

  function destroySlider() {
    if (splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
      slideSection.classList.remove('splide-initialized');
      slideSection.classList.remove('is-static');
      console.log(`[Splide] Slider #${sliderId} destroyed`);
    }
  }

  // Initial mount
  mountSlider();

  // Responsive handling on window resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newBreakpoint = getBreakpoint();
      if (newBreakpoint !== currentBreakpoint) {
        currentBreakpoint = newBreakpoint;
        console.log(`[Splide] Slider #${sliderId} breakpoint changed to ${newBreakpoint}, reinitializing`);
        destroySlider();
        mountSlider();
      }
    }, 150);
  });
}

function initAllCustomSpliders() {
  const sliders = document.querySelectorAll('section.splide.c-splide[data-slider-id]');
  console.log(`[Splide] Found ${sliders.length} sliders to initialize`);

  sliders.forEach((slider) => {
    initSplideSlider(slider);
  });
}

function syncSlideshowWrapperHeights() {
  document.querySelectorAll('.c-slideshow-wrapper').forEach((wrapper) => {
    const loopSlider = wrapper.querySelector('.c-splide.splide--loop');
    if (loopSlider) {
      wrapper.style.height = loopSlider.offsetHeight + 'px';
    } else {
      wrapper.style.height = '';
    }
  });
}

let syncResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(syncResizeTimeout);
  syncResizeTimeout = setTimeout(syncSlideshowWrapperHeights, 200);
});

document.addEventListener('DOMContentLoaded', () => {
  initAllCustomSpliders();
  syncSlideshowWrapperHeights();
});

document.addEventListener('shopify:section:load', (event) => {
  const sliders = event.target.querySelectorAll('section.splide.c-splide[data-slider-id]');
  sliders.forEach((slider) => {
    initSplideSlider(slider);
  });
  syncSlideshowWrapperHeights();
});
